import React from "react";
import FooterButtonGroup from "../modules/layout/FooterButtonGroup";
import Header from "../modules/layout/Header";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { applyStepState } from "../../recoil/pageStep";
import { userData } from "./ApplyRouter";
import { authState } from "../../recoil/auth";
import { speakLanguageToKorean } from "../../static";
import useApiActions from "../../recoil/api";

const ExamGuideFirst = () => {
  const setApplyStep = useSetRecoilState(applyStepState);
  const auth = useRecoilValue(authState);
  // const room_type = auth?.data?.room_type;
  // const koreanTitle = speakLanguageToKorean(room_type);
  const { setLog } = useApiActions();

  return (
    <div>
      <Header />
      <div className="base-sec" style={{ position: "relative" }}>
        <div className="background-color-w">
          <div className="base-sec-top flex">
            <div>
              {/* <p className="title">{koreanTitle}</p> */}
              <p className="title">영어 말하기 평가</p>
            </div>
          </div>
          <div className="base-sec-sec complete-sec text-align-center">
            {/*<Typography>시험 응시안내</Typography>*/}
            <div className="page-title text-align-center">
              <p>평가 응시안내</p>
            </div>
            <div className="welcome-box">
              <p className="welcome-text">
                {`안녕하세요, ${auth?.user?.payload?.user_name}님`}
                <br />
                KHNP 영어 말하기 모의평가 응시를 환영합니다.
              </p>
              <p className="welcome-ex">
                {/* 본 시험은
                <u>
                  <b> 영상면접(15)</b>
                </u>
                으로 진행되며 시험시간은
                <u>
                  <b> 약 50 분</b>
                </u>
                입니다. */}
                본 평가는 말하기 평가로 진행되며, 평가 시간은 약 30~50분
                소요됩니다.
                <br />
                아래 [<b>진행가이드</b>]를 정독 후 "다음"을 클릭하세요.
              </p>
            </div>
            <div className="progress-guide text-align-left">
              <p className="progress-guide-title">진행가이드</p>
              <ul className="progress-guide-list">
                {/* <li>- 영어말하기 시험의 총 문항 수는 15문항입니다.</li>
                <li className="text-blue">
                  ※ 각 문항마다 주어진 답변 준비 시간은 15초입니다.
                </li>
                <li className="text-blue">
                  ※ 최소 답변 시간은 30초이며, 최대 답변 시간은 3분입니다.
                </li>
                <li>- 답변 제출은 최소 답변시간이 지난 후 부터 가능합니다.</li>
                <li>
                  - 최대 답변시간을 초과하면 답변이 자동으로 제출되며, 다음
                  문항으로 넘어갑니다.
                </li>
                <li>
                  - 답변 도중 페이지를 빠져나갈 경우 해당 문항에 대한 답변은
                  저장되지 않으며, 재 접속 시 다음 문항부터 응시되므로 중간에
                  종료되지 않도록 유의 바랍니다.
                </li> */}
                <li>- 총 문항 수는 15문항입니다.</li>
                <li>- 각 문항마다 주어진 답변 준비 시간은 15초입니다.</li>
                <li>
                  - 최소 답변 시간은 30초이며, 최대 답변 시간은 3분입니다.
                </li>
                <li>- 답변 제출은 최소 답변 시간이 지난 후부터 가능합니다.</li>
                <li>
                  - 최대 답변 시간을 초과하면 답변이 자동으로 제출되며, 다음
                  문항으로 넘어갑니다.
                </li>
                <li>
                  - 답변 도중 페이지를 빠져나갈 경우 해당 문항에 대한 답변은
                  저장되지 않으며, 재 접속 시 카메라 테스트 이후 다음 문항부터
                  응시되므로 중간에 종료되지 않도록 유의 바랍니다.
                </li>
              </ul>
            </div>
          </div>
          <FooterButtonGroup
            prevOnClick={() => {
              setApplyStep((old) => {
                setLog({
                  params: {
                    text: `step ${old} => ${old - 1}`,
                  },
                });
                return old - 1;
              });
            }}
            nextOnClick={() => {
              setApplyStep((old) => {
                setLog({
                  params: {
                    text: `step ${old} => ${old + 1}`,
                  },
                });
                return old + 1;
              });
            }}
            preSelect="selected"
            nextSelect="selected"
          />
        </div>
      </div>
    </div>
  );
};

export default ExamGuideFirst;
